<template>
  <v-card>
    <v-card-title class="error white--text">
      Last payment error
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" xs="12" md="7">
          <div class="subtitle-1 grey--text">Details</div>
          <div class="mb-3">{{ getValueByKey('description') }} <pre class="grey--text">{{ errorCode() }}</pre></div>
          <div class="subtitle-1 grey--text">Next Steps</div>
          <div>{{ getValueByKey('next_steps') }}</div>
        </v-col>
        <v-col cols="12" xs="12" md="3">
          <info-list
            :list="paymentInfo()"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { get } from "lodash"
import InfoList from "../Common/InfoList"

export default {
  components: { InfoList },
  props: {
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      infoList: [
        {
          label: 'ID',
          value: 'test'
        },
      ]
    }
  },
  methods: {
    errorCode() {
      return get(this.invoice, 'payment_intent.last_payment_error.decline_code', 'generic_decline')
    },
    paymentInfo() {
      return [
        {
          label: 'Number',
          value: '****' + get(this.invoice, 'payment_intent.charges.data[0].payment_method_details.card.last4', ''),
        },
        {
          label: 'Expires',
          value: get(this.invoice, 'payment_intent.charges.data[0].payment_method_details.card.exp_month')
            + ' / '
            + get(this.invoice, 'payment_intent.charges.data[0].payment_method_details.card.exp_year')
        },
        {
          label: 'Type',
          value: get(this.invoice, 'payment_intent.charges.data[0].payment_method_details.card.brand'),
        },
        {
          label: 'Origin',
          value: get(this.invoice, 'payment_intent.charges.data[0].payment_method_details.card.country'),
        },
        {
          label: 'Status',
          value: get(this.invoice, 'status', ''),
        },
        {
          label: 'Description',
          value: get(this.invoice, 'payment_intent.description'),
        }
      ]
    },
    getValueByKey(key) {
      const code = this.errorCode()

      const translationKey = `stripe_decline_codes.${code}.${key}`
      const translated = this.$t(translationKey)

      // if there was no translation it will be the same as the translation key
      return translated === translationKey
        ? '--'
        : translated
    }
  }
}
</script>
